import * as React from "react"
import { Calendar, Home, Briefcase, HandCoins, Settings, ClipboardCheck, LayoutDashboard, Network, ChevronRight, TrendingUpDown, Info } from "lucide-react"
import SummerYouLogo from "../../assets/logo_mark_256x256_white.png"
import { NavHeader } from "./NavHeader"
import { NavFooter } from "./NavFooter"
import mainMenus from "../../configs/menu"

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  SidebarRail,
} from "../../components/ui/sidebar"
import { Collapsible } from "@radix-ui/react-collapsible"
import { CollapsibleContent, CollapsibleTrigger } from "../../components/ui/collapsible"
import { useNavigate } from "react-router-dom"

 const dataUser = {
    name: "shadcn",
    email: "m@example.com",
    avatar: "/avatars/shadcn.jpg",
  }

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const navigate = useNavigate();

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <NavHeader/>
      </SidebarHeader>
      <SidebarContent>

      {mainMenus.map((group) => (
        <SidebarGroup key={group.group}>
          {group.group && <SidebarGroupLabel>{group.group}</SidebarGroupLabel>}
          <SidebarGroupContent>
            <SidebarMenu>
            { group.items.map((menu) => 
              menu.subItems && menu.subItems.length > 0 ?  
              (                
                  <Collapsible asChild key={menu.title} className="group/collapsible">
                    <SidebarMenuItem>
                      <CollapsibleTrigger asChild>
                        <SidebarMenuButton tooltip={menu.title}>
                          {menu.icon && <menu.icon  />}
                          <span>{menu.title}</span>
                          <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90 group-data-[collapsible=icon]:hidden" />
                        </SidebarMenuButton>
                      </CollapsibleTrigger>
                      <CollapsibleContent>
                      <SidebarMenuSub>
                        {menu.subItems?.map((subItem) => (
                          <SidebarMenuSubItem key={subItem.title}>
                            <SidebarMenuSubButton asChild >
                              <a href={subItem.url} className="flex items-center gap-2">
                                <subItem.icon className="h-5 w-5"/>
                                <span>{subItem.title}</span>
                              </a>
                            </SidebarMenuSubButton>
                          </SidebarMenuSubItem>
                        ))}
                      </SidebarMenuSub>
                    </CollapsibleContent>
                    </SidebarMenuItem>

                  </Collapsible>
                )
                           
              : (
              <SidebarMenuItem key={menu.title}>
                <SidebarMenuButton asChild tooltip={menu.title} >
                  <a href={menu.url} >
                    <menu.icon className="group-data-[collapsible=icon]:block"/>
                    <span>{menu.title}</span>
                  </a>
                </SidebarMenuButton>
              </SidebarMenuItem>
            )) }
            
            </SidebarMenu>

            
          </SidebarGroupContent>
        </SidebarGroup> ))  
      
      }
      
      </SidebarContent>
      <SidebarFooter>
        <NavFooter/>
      </SidebarFooter>
          
      <SidebarRail />
    </Sidebar>
  )
}


